import { NurseFullRoleShort } from "../../../utils/models";

/**
 * Resolve a role to its short-code display value, with a stable fallback chain.
 *
 * Looks up `nurseRole` first (the role on the assigned nurse), then `fallbackRole` (the slot's
 * required role, used for gap rows or when no nurse is attached). For each source, if the role
 * key exists in `NurseFullRoleShort` returns the short code; otherwise returns the source string
 * as-is (preserves raw data rather than showing empty).
 *
 * Empty when both sources are absent.
 *
 * Used by `displayValue.ts`, `cellPopulator.ts`, and `sortKey.ts` so the certification / role
 * columns produce consistent fallbacks across sort, group, pivot label, and cell render.
 */
export const resolveRoleShortCode = (nurseRole: string | undefined, fallbackRole: string | undefined): string => {
	const source = nurseRole || fallbackRole;
	if (!source) return "";
	return NurseFullRoleShort[source as keyof typeof NurseFullRoleShort] ?? source;
};
